import { isEn } from "project-config/utils/env";
import { CouponSection } from ".";
import { CouponType, IUserInfoProps } from "./type";
import { getTranslateNsT } from "./i18n";
import { Button } from "task-eva-ui";
import { UserInfoDesktopTab } from "./atom";

export function DesktopTab({
  userInfo,
  toCoupon,
  close,
  toRecharge,
}: IUserInfoProps) {
  const {
    isDomestic,
    currencySymbol,
    isSubAccount,
    availableAmount,
    subAvailableAmount,
  } = userInfo;
  const amount = (isSubAccount ? subAvailableAmount : availableAmount) || 0;
  const t = getTranslateNsT(isEn() ? "en" : "zh");
  return (
    <UserInfoDesktopTab>
      <CouponSection
        onClick={() => {
          toCoupon?.(CouponType.Desktop, "desktop");
          close?.();
        }}
        isDomestic={!!isDomestic}
        isPictureUser={false}
        currencySymbol={currencySymbol}
        couponTitle={t("desktop_coin")}
        showCouponCount={false}
        couponPrice={amount}
      />
      {!isSubAccount && (
        <Button
          height="38px"
          width="100%"
          className="user-info-desktop-tab-button"
          onClick={() => {
            toRecharge?.("activeName=desktop-recharge");
            close?.();
          }}
        >
          {t("recharge")}
        </Button>
      )}
    </UserInfoDesktopTab>
  );
}
